"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useSetDictateState", {
  enumerable: true,
  get: function get() {
    return _useSetDictateState.default;
  }
});
var _useSetDictateState = _interopRequireDefault(require("./hooks/internal/useSetDictateState"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfdXNlU2V0RGljdGF0ZVN0YXRlIiwiX2ludGVyb3BSZXF1aXJlRGVmYXVsdCIsInJlcXVpcmUiLCJvYmoiLCJfX2VzTW9kdWxlIiwiZGVmYXVsdCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vc3JjL2ludGVybmFsLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VTZXREaWN0YXRlU3RhdGUgZnJvbSAnLi9ob29rcy9pbnRlcm5hbC91c2VTZXREaWN0YXRlU3RhdGUnO1xuXG5leHBvcnQgeyB1c2VTZXREaWN0YXRlU3RhdGUgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSxtQkFBQSxHQUFBQyxzQkFBQSxDQUFBQyxPQUFBO0FBQXFFLFNBQUFELHVCQUFBRSxHQUFBLFdBQUFBLEdBQUEsSUFBQUEsR0FBQSxDQUFBQyxVQUFBLEdBQUFELEdBQUEsS0FBQUUsT0FBQSxFQUFBRixHQUFBIn0=